import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/:uuid" element={<App />} />
        <Route path="/" element={<div>Please provide a UUID in the URL</div>} />
      </Routes>
    </Router>
  </React.StrictMode>
);
